import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import CardContent from "@mui/material/CardContent";
// import Seo from "../../../Components/Cms/Seo";
// import OGInfo from "../../../Components/Cms/OgInfo";
// import Twitterinfo from "../../../Components/Cms/TwitterInfo";
// import Editer from "../../../Components/Cms/Schema";
import Header from "../../../Components/Header/Header";
import Banner from "../../../Components/Cms/Banner";
import Goto from "../../../Components/Cms/Goto";
import classes from "./index.module.scss";
import RelatedCategory from "../../../Components/Cms/RelatedCategory";
import Text from "../../../Components/FormControl/Text/Text";
import TextArea from "../../../Components/FormControl/TextArea/TextArea";
import Select from "../../../Components/FormControl/Select/Select";
import WYSIWIGEditor from "../../../Components/WYSIWIGEditor/WYSIWIGEditor";
// Context
import { getAccessByModuleName } from "../../../Routes/Routes";
import { AppContext } from "../../../Context/AppContext";
import { LOCATION_TYPE, MODULES, META_CONTENT_DATA_KEY } from "../../../Helpers/Constants";
import { useLocation } from "../../../Context/Cms-Locations/useLocation";
import { getCategoryHierarchyList } from "api/category";
import {
  getCmsLocationsDetail,
  updateCmsLocations,
  createCmsLocations,
  getCmsLocationsRawDetail,
} from "api/cmsLocation";
import { postReqLocation } from "Hooks/locationDataApiCall";
import Seo from "Components/Cms/Seo";
import Oginfo from "Components/Cms/OgInfo";
import TwitterInfo from "Components/Cms/TwitterInfo";
import { OrderConfigContext } from "Context/OrderConfigContext";
import Faq from "./faqs";
import LocationTemplate, { defaultLocationTemplate, locationTemplateKey, readLocationTemplate, locationTemplateError } from "./location-template";

const AddLocations = () => {
  const { showToastMessage, modules, setIsLoading } = useContext(AppContext);
  const { storeList } = useContext(OrderConfigContext);
  const navigate = useNavigate();
  const params = useParams();
  const [categoryList, setCategoryList] = useState([]);
  const [updateLocationId, setUpdateLocationId] = useState();
  const [parentLocationId, setParentLocationId] = useState();
  const [template, setTemplate] = useState({ ...defaultLocationTemplate });

  const gotoList = [
    { id: "primary-information", title: "Primary Information" },
    { id: "banner-section", title: "Banner Style" },
    { id: "related-category", title: "Related Category" },
    // { id: "ralated-product", title: "Ralated Product" },
    // { id: "bottom-banner", title: "Bottom Banner" },
    // { id: "seo-section", title: "SEO" },
  ];

  useEffect(() => {
    clearLocationState();
    handleGetCategory();

    const { updateId, parentId } = params;
    setUpdateLocationId(updateId);
    setParentLocationId(parentId);
  }, []);

  useEffect(() => {
    if (updateLocationId) getLocationDataById(updateLocationId);
  }, [updateLocationId]);

  useEffect(() => {
    if (parentLocationId) getLocationRawData(parentLocationId);
  }, [parentLocationId]);

  const {
    locationState,
    addNewBanner,
    removeBanner,
    setBannerData,
    checkBannerData,
    setLocationBannerData,
    setLocationPrimaryData,
    setExistingRelatedCategoryData,
    clearLocationState,
    setSeoData,
    checkSeoData,
    setOgInfoData,
    checkOgInfoData,
    setTwitterInfoData,
    checkTwitterInfoData,
    setSchemaData,
    setMetaContentData,
    updateMetaContentData,
    updateFaqData,
    setFaqData,
  } = useLocation();

  // const [value, setValue] = useState();
  const [access, setAccess] = useState({});
  const [locationData, setLocationData] = useState({});
  const [metaContentDataIndex, setMetaContentDataIndex] = useState({
    service_offered:-1,
    need_opening_hour:-1,
    deliver_throughout_description:-1,
    your_local_florist_description:-1,
    description:-1,
    you_delivering_in: -1,
    best_seller: -1,
    store_information: -1,
    we_ve_worked_with: -1,
    brand_story: -1,
  });  
  /* Check Module Access */
  useEffect(getModuleAccess, [modules]);
  const metaContentDataKey = META_CONTENT_DATA_KEY;

  useEffect(() => {
    if(params && !params.updateId) {
      let metaContentData = [];
      Object.keys(metaContentDataKey).forEach((key, index) => {
        metaContentData.push({
          key: key,
          title: "",
          content: "",
        });
        setMetaContentDataIndex(prev => ({
          ...prev,
          [key]: index,
        }));
      });
      setMetaContentData(metaContentData || []);
    }
  }, []);

  // Access Contorol functionm call
  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.LOCATIONS);
    if (access) setAccess(access.permissions);
    if (access && !access.permissions.write_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }

  //get category details
  const handleGetCategory = async () => {
    setIsLoading(true);
    // const response = await categoryService.getCategoryHierarchyList();
    const response = await getCategoryHierarchyList();

    if (response && response.status === 200) {
      if (response.data.data && response.data.data.length) {
        let tempArr = [];
        response.data.data.forEach((element) => {
          let tempArrCat = {
            category_hierarchy_id: element.category_hierarchy_id,
            id: element.category_hierarchy_id,
            title: element.title,
            categoryTitle: element.categoryTitle,
          };
          tempArr.push(tempArrCat);
        });
        setCategoryList(tempArr);
      }
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const getLocationDataById = async (id) => {
    setIsLoading(true);
    const response = await getCmsLocationsDetail(id);
    if (response && response.status === 200) {
      if (response.data.data) {
        let tempResponseData = response.data.data;

        let locationStateData = { ...locationState.primary_info };
        setLocationPrimaryData({
          ...locationStateData,
          name: tempResponseData.name,
          type: tempResponseData.type,
          parent_id: tempResponseData.parent_id ?? null,
          main_parent_id: tempResponseData.main_parent_id ?? null,
          service_offered: tempResponseData.service_offered,
          need_opening_hour: tempResponseData.need_opening_hour,
          deliver_throughout_description: tempResponseData.deliver_throughout_description,
          your_local_florist_description: tempResponseData.your_local_florist_description,
          sequence_number: tempResponseData.sequence_number ?? 0,
          slug: tempResponseData.slug,
          blurb: tempResponseData.blurb,
          city_zipcodes: tempResponseData.city_zipcodes,
          store_id: tempResponseData.store_id ? tempResponseData.store_id : null,
          description: tempResponseData.description,
          status: tempResponseData.status,
        });

        tempResponseData.banners?.forEach((d, i) => {
          tempResponseData.banners[i]["module"] = "locations";
          setLocationBannerData(tempResponseData.banners[i]);
        });

        tempResponseData.cms_location_categories?.forEach((d, i) => {
          delete tempResponseData.cms_location_categories[i].category_hierarchy;
          delete tempResponseData.cms_location_categories[i].cms_location_id;
          delete tempResponseData.cms_location_categories[i].createdAt;
          delete tempResponseData.cms_location_categories[i].updatedAt;
          let tempArrCat = {
            category_hierarchy_id:
              tempResponseData.cms_location_categories[i]
                .category_hierarchy_id ?? null,
            seo: tempResponseData.cms_location_categories[i].seo ?? [],
          };
          setExistingRelatedCategoryData(tempArrCat);
        });

        setSeoData(tempResponseData.seo);
        setOgInfoData(tempResponseData.seo);
        setTwitterInfoData(tempResponseData.seo);
        setSchemaData(tempResponseData.seo);
        setTemplate(readLocationTemplate(tempResponseData.locationMetaContents));
        const metaContents = (tempResponseData.locationMetaContents || []).filter(item => item.key !== locationTemplateKey);
        setMetaContentData(metaContents);
        setFaqData(tempResponseData.cms_location_faqs || []);
        setLocationData({ ...tempResponseData, locationMetaContents: metaContents });
      }
    } else {
      setIsLoading(false);
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const getLocationRawData = async (id) => {
    setIsLoading(true);
    const response = await getCmsLocationsRawDetail(id);
    if (response && response.status === 200) {
      if (response.data.data) {
        let tempResponseData = response.data.data;

        let locationStateData = { ...locationState.primary_info };
        setLocationPrimaryData({
          ...locationStateData,
          parent_id: tempResponseData.id ?? 0,
          main_parent_id:
            tempResponseData.main_parent_id ?? tempResponseData.id ?? 0,
        });
      }
    } else {
      setIsLoading(false);
      showToastMessage(undefined, response.data.message, "error", false);
    }
    setIsLoading(false);
  };

  const handleSubmitClick = async (event) => {
    event.preventDefault();

    let showBannerError = false;
    locationState.banners.forEach((bannerData, index) => {
      const bannerSubmit = document.getElementById(
        `banner-submit-button-${index}`
      );
      if (bannerSubmit) {
        bannerSubmit.click();
      }
      if (!bannerData.image) {
        showBannerError = true;
      }
    });
    let locationApiCall = true;
    let validationMessage = "";
    if (locationState.banners.length > 0 && showBannerError) {
      locationApiCall = false;
      validationMessage = "Please enter required banner details";
    } else if (
      !locationState.primary_info.name ||
      locationState.primary_info.name?.trim() === ""
    ) {
      locationApiCall = false;
      validationMessage = "Please enter location name";
    } else if (
      !locationState.primary_info.type ||
      locationState.primary_info.type?.trim() === ""
    ) {
      locationApiCall = false;
      validationMessage = "Please select location type";
    } else if (
      !locationState.primary_info.slug ||
      locationState.primary_info.slug?.trim() === ""
    ) {
      locationApiCall = false;
      validationMessage = "Please enter location slug";
    } else if (locationState.cms_location_categories.length === 0) {
      locationApiCall = false;
      validationMessage = "Please enter minimum one related category";
    } else if (
      locationState.cms_location_categories.length > 0 &&
      locationState.cms_location_categories[0].category_hierarchy_id === null
    ) {
      locationApiCall = false;
      validationMessage = "Please enter minimum one related category";
    } else if (
      !locationState.primary_info.store_id &&
      locationState.primary_info.parent_id &&
      locationState.primary_info.main_parent_id &&
      locationState.primary_info.parent_id === locationState.primary_info.main_parent_id
    ) {
      locationApiCall = false;
      validationMessage = "Please select store";
    }

    const templateError = locationTemplateError(template);
    if (templateError) {
      locationApiCall = false;
      validationMessage = templateError;
    }

    if (locationApiCall) {
      setIsLoading(true);
      const post_req = postReqLocation(locationState);
      post_req.meta_content = [...post_req.meta_content, {
        key: locationTemplateKey, title: "", content: JSON.stringify(template), status: 1,
      }];
      if (updateLocationId !== "" && updateLocationId !== undefined) {
        let response = await updateCmsLocations(post_req, updateLocationId);
        if (response && response.status === 200) {
          showToastMessage(undefined, response.data.message, "success", false);
          clearLocationState();
          setIsLoading(false);
          navigate("/cms/locations");
        } else {
          setIsLoading(false);
          showToastMessage(undefined, response.data.message, "error", false);
        }
      } else {

        //filter the unnecessary data from post_req
        if(post_req.parent_id && post_req.main_parent_id && post_req.parent_id !== post_req.main_parent_id) {
          post_req.meta_content.forEach((item, index) => {
            if(item.key === metaContentDataKey.best_seller || item.key === metaContentDataKey.store_information || item.key === metaContentDataKey.you_delivering_in || item.key === metaContentDataKey.we_ve_worked_with || item.key === metaContentDataKey.deliver_throughout_description || item.key === metaContentDataKey.your_local_florist_description || item.key === metaContentDataKey.brand_story) {
              delete post_req.meta_content[index];
            }
          });
        }else if(!post_req.parent_id && !post_req.main_parent_id) {
          post_req.meta_content.forEach((item, index) => {
            if(item.key === metaContentDataKey.best_seller || item.key === metaContentDataKey.store_information || item.key === metaContentDataKey.you_delivering_in || item.key === metaContentDataKey.we_ve_worked_with || item.key === metaContentDataKey.deliver_throughout_description || item.key === metaContentDataKey.your_local_florist_description || item.key === metaContentDataKey.brand_story) {
              delete post_req.meta_content[index];
            }
          });
        }

        //Filter the null values from post_req
        post_req.meta_content = post_req.meta_content.filter(item => item !== null);

        let response = await createCmsLocations(post_req);
        if (response && response.status === 200) {
          showToastMessage(undefined, response.data.message, "success", false);
          clearLocationState();
          setIsLoading(false);
          navigate("/cms/locations");
        } else {
          setIsLoading(false);
          showToastMessage(undefined, response.data.message, "error", false);
        }
      }
    } else {
      showToastMessage(undefined, validationMessage, "error", false);
    }
  };

  useEffect(() => {
    if (updateLocationId && locationData && locationData.locationMetaContents){
      locationData.locationMetaContents.forEach((item, index) => {
        setMetaContentDataIndex(prev => ({
          ...prev,
          [item.key]: index,
        }));
      });
    }
  }, [locationData]);

  return (
    <React.Fragment>
      <Header title="CMS - Locations Page" />
      <div className="row">
        <div id="MainContent" className="col-8">
          <div className={`${classes.cardBody}`}>
            <CardContent>
              <div className={`row`} id={`primary-information`}>
                <div className={`col-md-6 col-xs-12`}>
                  <Text
                    type="text"
                    label="Location Name"
                    value={locationState.primary_info.name}
                    required={true}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        name: data,
                      });
                    }}
                    id="name"
                  />
                </div>
                <div className={`col-md-6 col-xs-12`}>
                  <Select
                    label="Type"
                    parentClass="text-center"
                    value={locationState.primary_info.type}
                    required={false}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        type: data,
                      });
                    }}
                    options={LOCATION_TYPE}
                    disabled={false}
                    id="state"
                  />
                </div>

                <div className={`col-md-6 col-xs-12`}>
                  <Text
                    type="text"
                    label="Sequence Number"
                    value={locationState.primary_info.sequence_number.toString()}
                    required={true}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      if (!/^[0-9]*$/.test(data)) {
                        return;
                      }
                      if (data.length > 10) {
                        return;
                      }
                      let val = data === "" ? "" : (+data).toString() || "";

                      setLocationPrimaryData({
                        ...locationStateData,
                        sequence_number: val,
                      });
                    }}
                    id="sequence_number"
                  />
                </div>
                {locationState.primary_info.status === 1 ? (
                  <div className={`cursor-pointer col-md-6 col-xs-12`}>
                    <label>Status</label>
                    <div className={classes.status}>
                      <div
                        className={classes.Active}
                        style={{ "font-weight": "bold" }}
                      >
                        Active
                      </div>
                      <div
                        className={classes.Inactive}
                        onClick={(data) => {
                          let locationStateData = {
                            ...locationState.primary_info,
                          };
                          setLocationPrimaryData({
                            ...locationStateData,
                            status: 0,
                          });
                        }}
                      >
                        Inactive
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={`cursor-pointer col-md-6 col-xs-12`}>
                    <label>Status</label>
                    <div className={classes.status}>
                      <div
                        className={classes.Active}
                        onClick={(data) => {
                          let locationStateData = {
                            ...locationState.primary_info,
                          };
                          setLocationPrimaryData({
                            ...locationStateData,
                            status: 1,
                          });
                        }}
                      >
                        Active
                      </div>

                      <div
                        className={classes.Inactive}
                        style={{ "font-weight": "bold" }}
                      >
                        Inactive
                      </div>
                    </div>
                  </div>
                )}
                <div className={`col-md-6 col-xs-12`}>
                  <Text
                    type="text"
                    label="Slug"
                    value={locationState.primary_info.slug}
                    required={true}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        slug: data,
                      });
                    }}
                    id="slug"
                  />
                </div>
                <div className={`col-md-6 col-xs-12`}>
                  <Text
                    type="text"
                    label="Blurb"
                    value={locationState.primary_info.blurb}
                    required={true}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        blurb: data,
                      });
                    }}
                    id="blurb"
                  />
                </div>
                <div className={`col-md-12 col-xs-12`}>
                  <TextArea
                    label="Zipcodes"
                    rows={3}
                    value={locationState.primary_info.city_zipcodes}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        city_zipcodes: data,
                      });
                    }}
                    id="city_zipcodes"
                  />
                </div>
                <LocationTemplate value={template} onChange={setTemplate} storeId={locationState.primary_info.store_id}
                  parentId={locationState.primary_info.parent_id} zipcodes={locationState.primary_info.city_zipcodes} />
                {/* Store Selection Option for sub location {one level hierarchy} */}
                { (template.template === "boutique" || (locationState.primary_info.parent_id &&
                  locationState.primary_info.main_parent_id && 
                  locationState.primary_info.parent_id === locationState.primary_info.main_parent_id)) && (
                  <div className={`col-md-6 col-xs-12`} style={{zIndex: 1000}}>
                    <Select
                      label="Select Store"
                      placeHolder="Select Store"
                      parentClass="text-left"
                      value={locationState.primary_info.store_id}
                      required={true}
                      onChange={(data) => {
                        let locationStateData = { ...locationState.primary_info };
                        setLocationPrimaryData({
                          ...locationStateData,
                          store_id: data,
                        });
                      }}
                      options={storeList || []}
                      disabled={false}
                    />
                  </div>
                  )
                }
                <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.description !== -1 ? "mt-2" : ""}`}>
                  {metaContentDataIndex.description !== -1 && 
                    <Text
                      type="text"
                      label="Description Heading"
                      // value={locationState?.meta_content[descriptionIndex]?.title || ""}
                      value={locationState?.meta_content[metaContentDataIndex.description]?.title || ""}
                      required={false}
                      onChange={(data) => {
                        let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.description] };
                        updateMetaContentData({
                          ...locationStateData,
                          title: data,
                        }, metaContentDataIndex.description);
                      }}
                      id="description-heading"
                    />
                  }
                </div>
                <div className={`row`}>
                    <label className="bmd-label-floating"
                    style={{ marginLeft: "25px" }}>Description</label>
                    <div className={`col-md-12 col-xs-12`}>
                      <WYSIWIGEditor 
                        data={locationState.primary_info.description}
                        onChange={(data) => {
                          let locationStateData = { ...locationState.primary_info };
                          //Update Description Content
                          if (metaContentDataIndex.description !== -1) {
                            let descriptionData = locationState.meta_content[metaContentDataIndex.description];
                            updateMetaContentData({
                              ...descriptionData,
                              content: data,
                            }, metaContentDataIndex.description);
                          }
                          setLocationPrimaryData({
                            ...locationStateData,
                            description: data,
                          });
                        }}
                      />
                    </div>
                </div>
                {/* <div className={`col-md-12 col-xs-12`}>
                  <TextArea
                    type="text"
                    label="description"
                    rows={3}
                    value={locationState.primary_info.description}
                    required={true}
                    onChange={(data) => {
                      let locationStateData = { ...locationState.primary_info };
                      setLocationPrimaryData({
                        ...locationStateData,
                        description: data,
                      });
                    }}
                    id="description"
                  />
                </div> */}
                {/* <div className={`col-md-12 col-xs-12`}>
                  <TextArea
                    type="text"
                    label="Service Offered"
                    rows={3}
                    value={value}
                    required={true}
                    onChange={(data) => console.log("Hello")}
                    id="service_offered"
                  />
                </div> */}
                {metaContentDataIndex.service_offered !== -1 && 
                  <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.service_offered !== -1 ? "mt-3" : ""}`}>
                     <Text
                      type="text"
                      label="Service Offered Heading"
                      value={locationState?.meta_content[metaContentDataIndex.service_offered]?.title || ""}
                      required={false}
                      onChange={(data) => {
                        let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.service_offered] };
                        updateMetaContentData({
                          ...locationStateData,
                          title: data,
                        }, metaContentDataIndex.service_offered);
                      }}
                      id="service-offered-heading"
                    />
                  </div>
                }
                <div className={`row`}>
                  <label
                    className="bmd-label-floating"
                    style={{ marginLeft: "25px" }}
                  >
                    Service Offered
                  </label>
                  <div className={`col-md-12 col-xs-12`}>
                    <WYSIWIGEditor
                      data={locationState.primary_info.service_offered}
                      height="200"
                      onChange={(data) => {
                        let locationStateData = {
                          ...locationState.primary_info,
                        };
                        //Update Service Offered Content
                        if (metaContentDataIndex.service_offered !== -1) {
                          let serviceOfferedData = locationState.meta_content[metaContentDataIndex.service_offered];
                          updateMetaContentData({
                            ...serviceOfferedData,
                            content: data,
                          }, metaContentDataIndex.service_offered);
                        }
                        setLocationPrimaryData({
                          ...locationStateData,
                          service_offered: data,
                        });
                      }}
                    />
                  </div>
                </div>

                {/* <div className={`col-md-12 col-xs-12`}>
                  <TextArea
                    type="text"
                    label="Opening Hour"
                    rows={3}
                    value={value}
                    required={true}
                    onChange={(data) => console.log("Hello")}
                    id="opening-hour"
                  />
                </div> */}

                {metaContentDataIndex.need_opening_hour !== -1 && 
                  <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.need_opening_hour !== -1 ? "mt-3" : ""}`}>
                    <Text
                      type="text"
                      label="Opening Hour Heading"
                      value={locationState?.meta_content[metaContentDataIndex.need_opening_hour]?.title || ""}
                      required={false}
                      onChange={(data) => {
                        let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.need_opening_hour] };
                        updateMetaContentData({
                          ...locationStateData,
                          title: data,
                        }, metaContentDataIndex.need_opening_hour);
                      }}
                      id="opening-hour-heading"
                    />
                  </div>
                }
                <div className={`row`}>
                  <label
                    className="bmd-label-floating"
                    style={{ marginLeft: "25px" }}
                  >
                    Opening Hour
                  </label>
                  <div className={`col-md-12 col-xs-12`}>
                    <WYSIWIGEditor
                      data={locationState.primary_info.need_opening_hour}
                      height="200"
                      onChange={(data) => {
                        let locationStateData = {
                          ...locationState.primary_info,
                        };
                        //Update Opening Hour Content
                        if (metaContentDataIndex.need_opening_hour !== -1) {
                          let openingHourData = locationState.meta_content[metaContentDataIndex.need_opening_hour];
                          updateMetaContentData({
                            ...openingHourData,
                            content: data,
                          }, metaContentDataIndex.need_opening_hour);
                        }
                        setLocationPrimaryData({
                          ...locationStateData,
                          need_opening_hour: data,
                        });
                      }}
                    />
                  </div>
                </div>
                {locationState.primary_info.parent_id && 
                  locationState.primary_info.main_parent_id && 
                  locationState.primary_info.parent_id === locationState.primary_info.main_parent_id && (
                  <>
                    {metaContentDataIndex.deliver_throughout_description !== -1 && 
                      <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.deliver_throughout_description !== -1 ? "mt-3" : ""}`}> 
                      <Text
                          type="text"
                          label="Deliver Throughout Description Heading"
                          value={locationState?.meta_content[metaContentDataIndex.deliver_throughout_description]?.title || ""}
                          required={false}
                          onChange={(data) => {
                            let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.deliver_throughout_description] };
                            updateMetaContentData({
                              ...locationStateData,
                              title: data,
                            }, metaContentDataIndex.deliver_throughout_description);
                          }}
                          id="deliver-throughout-description-heading"
                        />
                      </div>
                    }
                    <div className={`row`}>
                      <label
                        className="bmd-label-floating"
                        style={{ marginLeft: "25px" }}
                      >
                        Deliver Throughout Description
                      </label>
                      <div className={`col-md-12 col-xs-12`}>
                        <WYSIWIGEditor
                          data={locationState.primary_info.deliver_throughout_description}
                          height="200"
                          onChange={(data) => {
                            let locationStateData = {
                              ...locationState.primary_info,
                            };
                            //Update Deliver Throughout Description Content
                            if (metaContentDataIndex.deliver_throughout_description !== -1) {
                              let deliverThroughoutDescriptionData = locationState.meta_content[metaContentDataIndex.deliver_throughout_description];
                              updateMetaContentData({
                                ...deliverThroughoutDescriptionData,
                                content: data,
                              }, metaContentDataIndex.deliver_throughout_description);
                            }
                            setLocationPrimaryData({
                              ...locationStateData,
                              deliver_throughout_description: data,
                            });
                          }}
                        />
                      </div>
                    </div>
                    {metaContentDataIndex.your_local_florist_description !== -1 && 
                      <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.your_local_florist_description !== -1 ? "mt-3" : ""}`}>  
                        <Text
                          type="text"
                          label="Your Local Florist Description Heading"
                          value={locationState?.meta_content[metaContentDataIndex.your_local_florist_description]?.title || ""}
                          required={false}
                          onChange={(data) => {
                            let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.your_local_florist_description] };
                            updateMetaContentData({
                              ...locationStateData,
                              title: data,
                            }, metaContentDataIndex.your_local_florist_description);
                          }}
                          id="your-local-florist-description-heading"
                        />
                      </div>
                    }
                    <div className={`row`}>
                      <label
                        className="bmd-label-floating"
                        style={{ marginLeft: "25px" }}
                      >
                        Your Local Florist Description
                      </label>
                      <div className={`col-md-12 col-xs-12`}>
                        <WYSIWIGEditor
                          data={locationState.primary_info.your_local_florist_description}
                          height="200"
                          onChange={(data) => {
                            let locationStateData = {
                              ...locationState.primary_info,
                            };
                            //Update Your Local Florist Description Content
                            if (metaContentDataIndex.your_local_florist_description !== -1) {
                              let yourLocalFloristDescriptionData = locationState.meta_content[metaContentDataIndex.your_local_florist_description];
                              updateMetaContentData({
                                ...yourLocalFloristDescriptionData,
                                content: data,
                              }, metaContentDataIndex.your_local_florist_description);
                            }
                            setLocationPrimaryData({
                              ...locationStateData,
                              your_local_florist_description: data,
                            }, metaContentDataIndex.your_local_florist_description);
                          }}
                        />
                      </div>
                    </div>
                    {metaContentDataIndex.brand_story !== -1 && 
                      <div className={`col-md-12 col-xs-12 ${metaContentDataIndex.your_local_florist_description !== -1 ? "mt-3" : ""}`}>  
                        <Text
                          type="text"
                          label="Brand Story Heading"
                          value={locationState?.meta_content[metaContentDataIndex.brand_story]?.title || ""}
                          required={false}
                          onChange={(data) => {
                            let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.brand_story] };
                            updateMetaContentData({
                              ...locationStateData,
                              title: data,
                            }, metaContentDataIndex.brand_story);
                          }}
                          id="brand-story-heading"
                        />
                      </div>
                    }
                    <div className={`row`}>
                      <label
                        className="bmd-label-floating"
                        style={{ marginLeft: "25px" }}
                      >
                        Brand Story
                      </label>
                      <div className={`col-md-12 col-xs-12`}>
                        <WYSIWIGEditor
                          data={locationState.meta_content[metaContentDataIndex.brand_story]?.content || ""}
                          height="200"
                          onChange={(data) => {
                            //Update Brand Story Content
                            if (metaContentDataIndex.brand_story !== -1) {
                              let brandStoryData = locationState.meta_content[metaContentDataIndex.brand_story];
                              updateMetaContentData({
                                ...brandStoryData,
                                content: data,
                              }, metaContentDataIndex.brand_story);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className={`row`} id={`Other-Location-Page-Heading`}>
                <div className={`col-md-12 col-xs-12`}>
                  {locationState && 
                   locationState.primary_info.main_parent_id && locationState.primary_info.parent_id 
                   && locationState.primary_info.main_parent_id === locationState.primary_info.parent_id 
                    && metaContentDataIndex.best_seller !== -1 && 
                    <>
                      <Text
                        type="text"
                        label="Best Seller Heading"
                        value={locationState?.meta_content[metaContentDataIndex.best_seller]?.title || ""}
                        required={false}
                        onChange={(data) => {
                          let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.best_seller] };
                          updateMetaContentData({
                            ...locationStateData,
                            title: data,
                          }, metaContentDataIndex.best_seller);
                        }}
                        id="best-seller-heading"
                      />
                      <Text
                        type="text"
                        label="Best Seller Sub Text"
                        value={locationState?.meta_content[metaContentDataIndex.best_seller]?.content || ""}
                        required={false}
                        onChange={(data) => {
                          let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.best_seller] };
                          updateMetaContentData({
                            ...locationStateData,
                            content: data,
                          }, metaContentDataIndex.best_seller);
                        }}
                        id="best-seller-sub-text"
                      />
                    </>
                  }
                </div>
                <div className={`col-md-12 col-xs-12`}>
                  {locationState && locationState.primary_info.main_parent_id && locationState.primary_info.parent_id 
                    && locationState.primary_info.main_parent_id === locationState.primary_info.parent_id 
                    && metaContentDataIndex.store_information !== -1 && 
                    <Text
                      type="text"
                      label="Store Information Heading"
                      value={locationState?.meta_content[metaContentDataIndex.store_information]?.title || ""}
                      required={false}
                      onChange={(data) => {
                        let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.store_information] };
                        updateMetaContentData({
                          ...locationStateData,
                          title: data,
                        }, metaContentDataIndex.store_information);
                      }}
                      id="store-information-heading"
                    />
                  }
                </div>
                <div className={`col-md-12 col-xs-12`}>
                  {locationState && locationState.primary_info.main_parent_id && locationState.primary_info.parent_id 
                    && locationState.primary_info.main_parent_id === locationState.primary_info.parent_id 
                    && metaContentDataIndex.you_delivering_in !== -1 && 
                    <Text
                    type="text"
                    label="You Delivering In Heading"
                    value={locationState?.meta_content[metaContentDataIndex.you_delivering_in]?.title || ""}
                    required={false}
                    onChange={(data) => {
                      let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.you_delivering_in] };
                      updateMetaContentData({
                        ...locationStateData,
                        title: data,
                      }, metaContentDataIndex.you_delivering_in);
                    }}
                    id="you-delivering-in-heading"
                  />
                  }
                </div>
                <div className={`col-md-12 col-xs-12`}>
                  {locationState && locationState.primary_info.main_parent_id && locationState.primary_info.parent_id 
                    && locationState.primary_info.main_parent_id === locationState.primary_info.parent_id 
                    && metaContentDataIndex.we_ve_worked_with !== -1 && 
                    <Text
                    type="text"
                    label="We've Worked With Heading"
                    value={locationState?.meta_content[metaContentDataIndex.we_ve_worked_with]?.title || ""}
                    required={false}
                    onChange={(data) => {
                      let locationStateData = { ...locationState?.meta_content[metaContentDataIndex.we_ve_worked_with] };
                      updateMetaContentData({
                        ...locationStateData,
                        title: data,
                      }, metaContentDataIndex.we_ve_worked_with);
                    }}
                    id="we-ve-worked-with-heading"
                  />
                  }
                </div>
              </div>
              <Banner
                bannerModule="blogs"
                bannersData={locationState.banners}
                addNewBanner={addNewBanner}
                removeBanner={removeBanner}
                setBannerData={setBannerData}
                checkBannerData={checkBannerData}
                uploadImageType="LOCATIONS_BANNER"
              />
              <RelatedCategory categoryList={categoryList} />
              {/* <Seo />
              <OGInfo />
              <Twitterinfo /> */}
              {/* <Editer /> */}
              <div className="col-12 mt-5">
                { locationState && locationState.primary_info 
                    && locationState.primary_info.parent_id &&
                  <Faq setPageForView={locationState.setPageForView} />
                }
              </div>
              <Seo
                data={locationState.seo}
                setSeoData={setSeoData}
                checkSeoData={checkSeoData}
              />
              <Oginfo
                data={locationState.seo}
                setOgInfoData={setOgInfoData}
                checkOgInfoData={checkOgInfoData}
              />
              <TwitterInfo
                data={locationState.seo}
                setTwitterInfoData={setTwitterInfoData}
                checkTwitterInfoData={checkTwitterInfoData}
              />
              {/* <Editer 
                data={locationState.seo}
                setSchemaData={setSchemaData}
                checkSchemaData={checkSchemaData}
              /> */}
            </CardContent>
          </div>
        </div>
        <div className="col-4">
          <Goto gotoList={gotoList} handleSubmitClick={handleSubmitClick} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddLocations;
